import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	sbButton: {
		textTransform: "capitalize !important",
	} as any,
}));
